var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_218_11014)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.282 160.705C215.099 161.251 197.404 199.803 192.685 219.148C189.834 254.074 222.248 261.928 229.75 256.925C233.945 254.129 242.484 250.418 248.639 249.156C254.794 250.418 263.333 254.129 267.527 256.925C275.029 261.928 307.444 254.074 304.592 219.148C299.874 199.803 282.179 161.251 248.996 160.705V160.699C248.876 160.699 248.758 160.7 248.639 160.701C248.52 160.7 248.401 160.699 248.282 160.699V160.705Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.176 285.054L146.861 560H353.595L333.131 269.313C357.478 228.596 356.218 176.79 352.545 155.977C345.829 117.358 324.911 117.498 315.291 122.396C314.452 92.1725 303.746 87.2402 287.482 82.5179C263.868 79.3696 251.625 94.2362 247.078 104.031C247.078 93.0119 237.108 83.9732 229.762 82.5179C185.267 73.7029 177.294 105.43 176.769 122.396C167.954 117.778 154.05 122.815 147.384 128.692C107.506 163.847 141.614 259.868 164.176 285.054Z",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 166.273,
    cy: 160.699,
    rx: 14.6918,
    ry: 16.7906,
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 319.487,
    cy: 160.699,
    rx: 14.6918,
    ry: 16.7906,
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.496,
    cy: 119.772,
    rx: 14.6918,
    ry: 16.7906,
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 279.609,
    cy: 119.772,
    rx: 14.6918,
    ry: 16.7906,
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.777 476.889L417.252 417.364",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359.216,
    cy: 326.588,
    r: 107.084,
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.199 227.579L361.689 274.439C361.98 275.45 362.784 276.228 363.79 276.537C387.692 283.866 401.676 308.874 395.153 333.218C388.641 357.524 364.093 372.181 339.766 366.65C338.679 366.403 337.53 366.727 336.774 367.547L300.018 407.395",
    stroke: "black",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.383 251.05C363.494 258.57 365.371 275.941 379.991 285.264C387.165 289.314 399.646 303.82 392.178 329.448C389.516 341.248 377.304 364.504 349.743 363.126C344.166 362.847 333.959 368.373 329.391 381.642L327.969 386.948C328.343 385.057 328.823 383.29 329.391 381.642L364.383 251.05Z",
    fill: "url(#paint0_linear_218_11014)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 362.129,
    cy: 334.822,
    rx: 8.58928,
    ry: 6.1394,
    transform: "rotate(121.484 362.129 334.822)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_218_11014",
    x1: 391.969,
    y1: 330.331,
    x2: 346.32,
    y2: 318.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#282828",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_218_11014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/피부과_피부 종양.35d1a1d7f625bb72e279316a01e838d5.svg";
export { ForwardRef as ReactComponent };